import axios from "@/plugins/axios";

// initial state
const state = () => ({
  items: [],
  item: {}
});

// getters
const getters = {
  items: (state) => state.items,
  item: (state) => state.item
};

// actions
const actions = {
  reset({ commit }) {
    commit("SET_ITEMS", []);
    commit("SET_ITEM", {});
  },

  // Fetch all available markets from API
  fetch({ commit }) {
    return new Promise((success, failure) => {
      axios
        .post("/", {
          query: `
            {
              taxomarches(parent:0, depth:1) {
                marche {
                  id
                  name
                  url
                  logo
                  language
                  image_process
                }
              }
            }
            `
        })
        .then((response) => {
          if (response.data.data && response.data.data.taxomarches) {
            commit("SET_ITEMS", response.data.data.taxomarches.marche || []);
            success(response);
          }
        })
        .catch((error) => {
          console.log(error);
          failure(error);
        });
    });
  },

  // Find a specific market by id in store
  find({ commit, state }, id) {
    const item = state.items.find(function(market) {
      if (market.id == id) return market;
    });
    commit("SET_ITEM", item || {});
    return item || null;
  }
};

// mutations
const mutations = {
  SET_ITEMS(state, value) {
    state.items = value;
  },
  SET_ITEM(state, value) {
    state.item = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
